<template>
  <iMineTemplate
    :pageTitle="pageTitle"
    :activedParentKey="activedParentKey"
    :activedKey="activedKey"
  >
    <template #rightContent>
      <ApplyInvoiceForm height='auto' />
    </template>
  </iMineTemplate>
</template>

<script>
import { BaseMixin } from "../../mixins/BaseMixin";
export default {
  mixins: [BaseMixin],
  name: "ApplyInvoice",
  data() {
    return {
      pageTitle: ["我的账户", "开票信息"],
      activedParentKey: 1,
      activedKey: 15
    };
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="less">
</style>